<template>
  <div>
    <!-- RK海外仓集运授权设置 -->
    <el-dialog :title="$t('message.rkOverseasWarehouseConsolidationAuthSettings')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="488px" center>
      <div class="content">
        <!-- Rakumart海外仓授权 -->
        <div class="row">
          <el-checkbox v-model="is_overseas_warehouse">{{ $t('message.rakumartOverseasWarehouseAuthorization')
          }}</el-checkbox>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,
      is_overseas_warehouse: false,
      searchText: "",
      list: []
    };
  },

  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.is_overseas_warehouse = this.detail.is_overseas_warehouse == 1 ? true : false
      }
    }
  },
  methods: {
    // 保存
    save() {
      let datas = {
        user_id: this.$route.query.userID,
        is_overseas_warehouse: this.is_overseas_warehouse ? 1 : 0,
      };
      this.$api.clienteleApi.setOverseasWarehouse(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.clientDetail();
      });

    }

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  padding: 24px;
  background: #f8f8f8;
  border-radius: 8px;



  .row {
    margin-bottom: 24px;
    display: flex;
    line-height: 40px;

    .input {

      margin: 0 12px;
    }
  }

  /deep/.el-radio__input {
    transform: scale(1.5) !important;
  }
}

.ul {
  max-height: 400px;
  overflow-y: auto;
}
</style>